import React from 'react';
import classNames from 'classnames';
import { Popover } from '@headlessui/react';

type TTooltipProps = {
  title: string | React.ReactElement;
  content: string;
  popoverClassName?: string;
  buttonClassName?: string;
  panelClassName?: string;
  contentClassName?: string;
};

export const Tooltip: React.FC<TTooltipProps> = ({
  title,
  content,
  popoverClassName,
  buttonClassName,
  panelClassName,
  contentClassName
}) => (
  <Popover className={classNames(popoverClassName)}>
    <Popover.Button
      className={classNames('block', buttonClassName)}
      title="Learn more"
    >
      {title}
    </Popover.Button>
    <Popover.Panel
      className={classNames(
        'absolute z-10 transform bg-white sm:px-0',
        panelClassName
      )}
    >
      <div
        className={classNames(
          'block max-w-xs px-4 py-2 text-sm font-normal text-left text-gray-500  shadow-lg ring-1 ring-black ring-opacity-5 ',
          contentClassName
        )}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </Popover.Panel>
  </Popover>
);

Tooltip.defaultProps = {
  popoverClassName: undefined,
  buttonClassName: undefined,
  panelClassName: undefined,
  contentClassName: undefined
};
